import { ChakraProvider } from "@chakra-ui/provider";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { AppProps } from "next/app";
import Script from "next/script";
import theme from "theme";

function MyEmotionProvider({ nonce, children }) {
  const cache = createCache({ nonce, key: "landing-app" });
  // eslint-disable-next-line react/no-children-prop
  return <CacheProvider value={cache} children={children} />;
}

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      {/* Global site tag (gtag.js) - Google Analytics */}
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-167363091-1"
        strategy="afterInteractive"
        nonce="5rTfmhMZEqh6Qtzt7BwS"
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        nonce="5rTfmhMZEqh6Qtzt7BwS"
      >
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'UA-167363091-1');
        `}
      </Script>
      {/* Cookiebot CMP */}
      <Script
        id="Cookiebot"
        src="https://consent.cookiebot.com/uc.js"
        data-cbid="19330543-a802-4480-99b5-34eb90085c29"
        data-blockingmode="auto"
        type="text/javascript"
        nonce="5rTfmhMZEqh6Qtzt7BwS"
      />
      <MyEmotionProvider nonce="5rTfmhMZEqh6Qtzt7BwS">
        <ChakraProvider resetCSS theme={theme}>
          <Component {...pageProps} />
        </ChakraProvider>
      </MyEmotionProvider>
    </>
  );
}

export default MyApp;
